import { useCallback, useEffect } from 'react'
import * as Sentry from '@sentry/react'

import { useAppNavbar } from '@/shared/hooks/use-app-navbar'
import { getLocalStorageValue } from '@/shared/hooks/use-local-storage'
import { useTheme } from '@/shared/hooks/use-theme'
import { currencyParser } from '@/shared/lib/currency-parser'
import { navigateToDriverAppCity } from '@/shared/lib/navigate'
import { AppsflyerEvent, sendAppsflyer } from '@/shared/metrics'
import { Button } from '@/shared/ui'

import { getStoredPaymentMethod } from '@/features/payment-method'

// TODO: Временно убераем так как пока не готов бэк
// import { Csat } from '@/widgets'
import styles from './driver-recharge-success.module.scss'

import { IllustrationSuccessDark, IllustrationSuccessLight } from '@/assets'

export const DriverRechargeSuccess = (): React.ReactNode => {
    const { theme } = useTheme()
    const illustration = theme === 'light' ? IllustrationSuccessLight : IllustrationSuccessDark

    useAppNavbar(' ', null, null)

    const amount = currencyParser(getLocalStorageValue<number>('driver-recharge-amount', 0))

    const payment_method = getStoredPaymentMethod().id

    useEffect(() => {
        sendAppsflyer(AppsflyerEvent.finance_topup_success_view, {
            payment_method,
        })
    }, [payment_method])

    const handleClick = useCallback((): void => {
        try {
            navigateToDriverAppCity()
        } catch (error) {
            Sentry.captureException(error, {
                tags: {
                    errorType: 'driver-recharge-success',
                },
            })
        }
    }, [])

    return (
        <>
            <div className={styles['driver-recharge-success__content']}>
                <img
                    alt='Illustration Success'
                    className={styles['driver-recharge-success__illustration']}
                    src={illustration}
                />
                <h1
                    className={styles['driver-recharge-success__title']}
                    data-test-id='driver-recharge-success-title'
                >
                    Почти готово
                </h1>
                <p className={styles['driver-recharge-success__description']}>
                    Счёт будет пополнен на{' '}
                    <span
                        className={styles['driver-recharge-success__description-balance']}
                        data-test-id='driver-recharge-success-amount'
                    >
                        {amount} ₽
                    </span>{' '}
                    через пару
                    <br /> минут
                </p>
                <Button
                    className={styles['driver-recharge-success__button']}
                    data-test-id='driver-recharge-success-button'
                    size='large'
                    variant='primary'
                    onClick={handleClick}
                >
                    Перейти к заказам
                </Button>
            </div>
            {/* TODO: Временно убераем так как пока не готов бэк */}
            {/* <Csat /> */}
        </>
    )
}
